export default __webpack_public_path__ + "static/media/bancop-logo.d321e90c.png";